import * as React from "react";

//<DienteMo pza={18} pieza={pieza} color={color} width={40} height={52} style={{ top:'272', left:'66'}}
//          className="di resalte1"/>
const Barra = (props) => {

  //let color= props.color || '#fff';
  //let backColor= '#fff';
  let ancho= props.width || 50;
  let alto= props.height || 10;
  
  
  //no se dibujan los que tienen el valor de backColor=""
  let backColor= props.backColor;
  //let numero = props.pza;
  return (
  <svg 
          version="1.1"
          viewBox="0 0 14.868106 15.163974"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
      >
    {backColor!=="" &&
      <rect width={ancho} height={alto} fill={backColor}/>
     }

  </svg>
)};
export default Barra;